module.exports = __webpack_public_path__ + "assets/img/SEOClarity-Landing-Page-+-Website.ca1e582d.webp";